export interface SeveritiesSet {
  Informative: boolean;
  Low: boolean;
  Medium: boolean;
  High: boolean;
  Critical: boolean;
}

interface SeverityDdlItem {
  label: string;
  value: string;
  selected: boolean;
}

export function severitiesAll(): SeveritiesSet {
  return { Critical: true, High: true, Medium: true, Low: true, Informative: true };
}

export function severitiesNone(): SeveritiesSet {
  return { Critical: false, High: false, Medium: false, Low: false, Informative: false };
}

export function severitiesHighAndCrtitcal(): SeveritiesSet {
  return { Critical: true, High: true, Medium: false, Low: false, Informative: false };
}

export const SeverityNames = Object.keys(severitiesAll()) as (keyof SeveritiesSet)[];

export function getSeverityDdlItems(severities: SeveritiesSet): SeverityDdlItem[] {
  if (!severities) return [];
  return SeverityNames.map(key => {
    return {
      label: key,
      value: key,
      selected: severities[key]
    };
  });
}

export function getEnabledSeverities(severities: SeveritiesSet): string[] {
  if (!severities) return [];
  return SeverityNames.filter(key => severities[key]);
}

export function getSeverities(severitiesList: (keyof SeveritiesSet)[] | undefined): SeveritiesSet {
  if (!severitiesList) {
    return severitiesNone();
  }
  if (!Array.isArray(severitiesList)) {
    severitiesList = [severitiesList];
  }
  return severitiesList.reduce((acc, severity) => {
    acc[severity] = true;
    return acc;
  }, severitiesNone());
}
